// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3zag0","label":"LabeledBox_label__fw6sU"};